import { type PropsWithChildren } from "react";
import { ModuleWorkspaceBoundary } from "./ModuleWorkspaceBoundary.tsx";

export function ModuleAuthenticatedProviders({ children }: PropsWithChildren) {
    return <ModuleWorkspaceBoundary>{children}</ModuleWorkspaceBoundary>;
}
